import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@athena/ui/lib/utils";

const badgeVariants = cva(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
    {
        variants: {
            variant: {
                default: "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
                secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
                destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
                // For "be careful", as distinct from `destructive`'s "this went wrong". The
                // environment badge in the admin shell is the first use: a non-production
                // deployment is a caution, not an error, and red reads as something broken.
                warning: "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
                outline: "text-foreground",
                tag: "border-transparent bg-muted text-muted-foreground font-normal",
                dottedOutline: "border-dashed hover:bg-muted/80 hover:cursor-pointer p-2",
            },
        },
        defaultVariants: {
            variant: "default",
        },
    },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
    return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
